<div appEditableComponent [class]="specialBlock.uId" class="slides-content" [class.has-aspect-ratio]="blockHasAspectRatio">

  <div (click)="onSlide(-1)"
       [class]="leftArrow.uId"
       [item]="leftArrow"
       app-block
       class="slides-content__left">
  </div>

  <!-- <div #container class="slideshow-container">
    <div *ngFor="let slide of slides; index as i"
         [class.hide-slide]="!slide?.isSelected && !slide?.leftSide && !slide?.rightSide"
         [class.left-side]="slide?.leftSide"
         [class.right-side]="slide?.rightSide"
         [class.selected]="slide?.isSelected"
         [class.slide-not-selected]="!slide?.isSelected"
         [class.slide-in-left]="slide?.action === 'slideInLeft'"
         [class.slide-in-right]="slide?.action === 'slideInRight'"
         [class.slide-out-left]="slide?.action === 'slideOutLeft'"
         [class.slide-out-right]="slide?.action === 'slideOutRight'"
         [style.animation-duration.ms]="animationDuration"
         class="slides">

      <div [class]="slide.uId"
           [item]="slide"
           app-block>
      </div>

    </div>
  </div> -->

  <div #container class="slideshow-container">

    <div *ngFor="let slide of slides; index as i"
         [class.hide-slide]="!slide?.isSelected && !slide?.leftSide && !slide?.rightSide"
         [class.left-side]="slide?.leftSide"
         [class.right-side]="slide?.rightSide"
         [class.selected]="slide?.isSelected"
         [class.slide-not-selected]="!slide?.isSelected"
         [class.slide-in-left]="slide?.action === 'slideInLeft'"
         [class.slide-in-right]="slide?.action === 'slideInRight'"
         [class.slide-out-left]="slide?.action === 'slideOutLeft'"
         [class.slide-out-right]="slide?.action === 'slideOutRight'"
         [style.animation-duration.ms]="animationDuration"
         class="slides">
      <div [class]="slide.uId" [item]="slide" app-block></div>
    </div>
  </div>


  <div (click)="onSlide(1)"
       [class]="rightArrow.uId"
       [item]="rightArrow"
       app-block
       class="slides-content__right">
  </div>
</div>
